import { addDoc, collection, deleteDoc, doc, setDoc } from 'firebase/firestore';
import { db } from '@/db';
import { WriteRepository } from './WriteRepository';
import { normalizeLicenseDateFields } from '../licenseDates';

export class FirestoreWriteRepository extends WriteRepository {
  async patchDoc(path, patch, { merge = true } = {}) {
    return this.setDoc(path, patch, { merge });
  }

  async setDoc(path, data, { merge = true } = {}) {
    const firestore = await db;
    if (/^cities\/[^/]+\/licenses\/[^/]+$/.test(path)) data = normalizeLicenseDateFields(data);
    return setDoc(doc(firestore, path), data, { merge });
  }

  async createDoc(collectionPath, data) {
    const firestore = await db;
    if (/^cities\/[^/]+\/licenses$/.test(collectionPath)) data = normalizeLicenseDateFields(data);
    const docRef = await addDoc(collection(firestore, collectionPath), data);
    return {
      id: docRef.id,
      path: docRef.path
    };
  }

  async deleteDoc(path) {
    const firestore = await db;
    return deleteDoc(doc(firestore, path));
  }
}
